import React from "react";
import Ankedi1 from "../../assets/img/Ankedi1.webp";
import "./Home.scss";

const Home = () => {
  return (
    <div className="home">
      <h1 className="home__name">
        Turkish <span>Angora Cat</span>
      </h1>
    </div>
  );
};

export default Home;
